import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './radio_button.scss'

class RadioButton extends PureComponent {

	constructor() {
		super()
		this.keyPress = this.keyPress.bind(this)
	}

	keyPress(e) {
		if (e.charCode === 32) {
			this.props.onChange(!this.props.value)
		}
	}

	render() {
		return (
			<label
				tabIndex={0}
				htmlFor={this.props.id}
				onBlur={this.props.onBlur}
				onFocus={this.props.onFocus}
				onKeyPress={this.keyPress}
				styleName={
					classNames({
						wrapper: true,
						'wrapper--error': this.props.status === 'error',
						'wrapper--disabled': this.props.disabled,
					})
				}
			>
				<input
					onChange={this.props.onChange}
					styleName='input'
					type='radio'
					id={this.props.id}
					value={this.props.value}
					checked={this.props.checked}
					disabled={this.props.disabled} />
				<span styleName='circle'></span>
			</label>
		)
	}

}

RadioButton.propTypes = {
	status: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	value: PropTypes.string,
	checked: PropTypes.bool,
	id: PropTypes.string,
	disabled: PropTypes.bool,
}

RadioButton.defaultProps = {
	status: '',
	onBlur: () => {},
	onChange: () => {},
	onFocus: () => {},
	disabled: false,
}

export default CSSModules(RadioButton, styles, {allowMultiple: true})
